<template>
    <div class="expired-product-body">
        <div class="expired-product-body__prefix" :class="{ 'expired-product-body__prefix--taller': tallerPrefix }">
            {{ $t('ProductExpiredSubscribe.prefix') }}
        </div>

        <SubscribeToProductForm :product-details="productDetails" @subscribed="hasSubscribed = true">
            <template #header>
                {{ $t('ProductExpiredSubscribe.heading') }}
            </template>

            <template #description>
                <p>
                    {{ $t('ProductExpiredSubscribe.description') }}
                </p>
            </template>

            <template #append>
                <translate path="ProductExpiredSubscribe.dataProtection" tag="small" class="d-block">
                    <template #link>
                        <nuxt-link
                            :to="{ name: 'category', params: { category: 'datenschutz' } }"
                            target="_blank"
                            @click.native="$event.stopImmediatePropagation()"
                        >
                            {{ $t('DataProtection.link').trim() }}
                        </nuxt-link>
                    </template>
                </translate>
            </template>

            <template #subscribed>
                <p class="mb-0">
                    {{ $t('ProductExpiredSubscribe.subscribed') }}
                </p>
            </template>
        </SubscribeToProductForm>

        <WaitlistOtherProducts
            v-if="hasSubscribed && $store.state.ident !== 'nettovorteilswelt'"
            class="expired-product-body__suffix"
        />
    </div>
</template>

<script>
import SubscribeToProductForm from '@/components/product/SubscribeToProduct.vue';
import WaitlistOtherProducts from '@/components/product/auction/WaitlistOtherProducts.vue';

export default {
    name: 'ProductExpiredSubscribe',
    components: { WaitlistOtherProducts, SubscribeToProductForm },

    data() {
        return {
            hasSubscribed: false
        };
    },

    props: {
        productDetails: {
            type: Object,
            required: true
        },

        tallerPrefix: Boolean
    }
};
</script>

<style scoped lang="scss">
.expired-product-body {
    &__prefix {
        background-color: var(--soldout-color);
        color: var(--white);
        padding: 1rem;
        border-bottom-right-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
        font-size: 0.875rem;
        text-align: center; //better on mobile

        &--taller {
            margin-top: -1.3rem;
            padding-top: 2rem;
            margin-inline: -1px;
        }
    }

    &__suffix {
        padding: 1rem;
        border-top: 1px solid var(--border-color);
    }
}
</style>
